export const APPLICATION_SHOW_RESET = 'APPLICATION_SHOW_RESET'
export const APPLICATION_SHOW_SET_ERROR = 'APPLICATION_SHOW_SET_ERROR'
export const APPLICATION_SHOW_SET_RETRIEVED = 'APPLICATION_SHOW_SET_RETRIEVED'
export const APPLICATION_SHOW_TOGGLE_LOADING = 'APPLICATION_SHOW_TOGGLE_LOADING'
